import React, { useEffect, useState } from "react";
import { htmlToText } from 'html-to-text';
import { MdOutlineContentCopy } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { SlRefresh } from "react-icons/sl";
import { Skeleton } from "antd";
import { fetchAISummary } from "./useGetProfileDetails";
import { useParams } from "react-router";
import useSubmitLog from "./useSumbitLog";

const PopupHandler = ({ name, showAIPopup, setShowAIPopup }) => {
  const [aiSummary, setAISummary] = useState("");
  const [summaryLoader, setSummaryLoader] = useState(false);
  const [copied, setCopied] = useState(false);

  const { companyId: id } = useParams();
  const submitLog = useSubmitLog();
  const getAISummaryHandler = async (id) => {
    setAISummary("");
    setSummaryLoader(true);
    submitLog("AIS");
    if (!showAIPopup) {
      setShowAIPopup(true);
    }
    try {
      const summary = await fetchAISummary(id);
      if (summary) {
        setAISummary(summary.summary);
      }
    } catch (error) {
      console.error("Error fetching AI summary:", error);
      setAISummary(error.response.data.summary);
    } finally {
      setSummaryLoader(false);
    }
  };

  useEffect(() => {
    if (showAIPopup) {
      getAISummaryHandler(id);
    }
  }, [id]);

const handleCopy = async () => {
  try {
    // Convert HTML string to plain text
    const plainText = htmlToText(aiSummary, {
      wordwrap: 130,
      selectors: [
        { selector: 'a', options: { ignoreHref: true } },
        { selector: 'img', format: 'skip' },
      ],
    });

    await navigator.clipboard.writeText(plainText);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset after 2s
  } catch (err) {
    console.error("Failed to copy:", err);
  }
};

  return (
    <div className="flex font-sans_book_body cursor-default justify-center items-center z-10 fixed left-0 top-0 w-screen h-screen bg-gray-500 bg-opacity-40 backdrop-blur-lg transition-opacity">
      <div className="relative p-6 pr-2 pt-2 flex flex-col w-[95%] md:w-[60%] h-3/4 max-h-[600px] bg-white rounded-xl overflow-y-auto shadow-xl transition-all duration-300 no-scrollbar">
        <div className="absolute flex items-center justify-center lg:z-[150] md:z-[150] z-[150] right-[-28px] h-[1.2rem] px-6 mt-1 lg:right-[-28px] md:right-[-27px] rotate-[50deg] bg-red-600 text-white">
          <h3 className="tracking-widest font-semibold text-sm ">BETA</h3>
        </div>
        <div className="flex justify-between items-end border-b pb-2 mb-2 pr-8">
            <h2 className="text-lg font-semibold text-gray-800">{name}</h2>
            <div className="flex items-center gap-2">
              {!summaryLoader && <>
                <p className="text-red-800">Feel AI has not got it right ?</p>
                <button
                    className="p-2 hover:bg-gray-200 hover:text-black focus:outline-none rounded-md"
                    onClick={() => getAISummaryHandler(id)}
                    title="Generate an alternative summary"
                    >
                    <SlRefresh size={15} />
                    </button>
              </>}
                <button
                    onClick={() => setShowAIPopup(false)}
                    className="p-2 rounded-md hover:bg-gray-200 transition-all"
                    >
                    <IoMdClose size={20} className="text-gray-600" />
                </button>
            </div>
        </div>
        <div className="w-full flex flex-col h-full">
          <div className="markdown">
            {summaryLoader ? (
              <div className="h-60 flex flex-col justify-between items-center font-bold">
                "Analyzing VI data and crafting your summary..."
                <Skeleton />
                <Skeleton />
              </div>
            ) : (
              <>
                <div
                  dangerouslySetInnerHTML={{ __html: aiSummary }}
                  style={{
                    lineHeight: "1.6",
                    color: "#374151",
                  }}
                />
                <div className="flex justify-start items-center gap-1 mt-6 my-4">
                  {aiSummary !==
                    "There was an error in generating the company profile" && (
                    <div>
                      <button
                        onClick={handleCopy}
                        className="p-2 hover:bg-gray-200 hover:text-black focus:outline-none rounded-md"
                        title="Copy to clipboard"
                      >
                        {copied ? (
                          <FaCheck size={20} />
                        ) : (
                          <MdOutlineContentCopy size={20} />
                        )}
                      </button>
                      <button
                        className="p-2 hover:bg-gray-200 hover:text-black focus:outline-none rounded-md"
                        onClick={() => getAISummaryHandler(id)}
                        title="Generate an alternative summary"
                      >
                        <SlRefresh size={20} />
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupHandler;